export const TITLE = 'Select Price Range';
export const BTN_TEXT = 'Apply';
export const MIN_ERROR_MSG = 'Minimum amount is';
export const MAX_ERROR_MSG = 'Maximum amount is';
export const DEBOUNCE_DELAY = 1000;
export const MIN_AMOUNT = 'Min. Amount';
export const MAX_AMOUNT = 'Max. Amount';
export enum SLIDER_STATES {
  NONE,
  LEFT,
  RIGHT,
}
export enum INPUT_TYPES {
  MIN,
  MAX,
  NONE,
}
